import { AUTH0_DOMAIN, AUTH0_CALLBACK_URL } from "./auth0-variables";
import { Auth0Client } from "@auth0/auth0-spa-js";
import createAuth0Client from "@auth0/auth0-spa-js";

/**
 * This function Fetchs Authorization Settings  before angular app is bootstraped.
 * it is whe the document is ready.
 * @param envName current environment name.
 * @returns
 */
export function loadAuthSettings(envName: string): Promise<Auth0Client> {
	const url = envName == 'Production' ? 
		'https://api-internal.everymundo.io/user-service/v2/authentication/metadata' : 
        envName ==  "Prepro" ? 'https://api-staging.everymundo.io/user-service/v2/authentication/metadata' :
		'https://api-dev.everymundo.io/user-service/v2/authentication/metadata'; 
	
	return fetch(url)
		.then(result => result.json())
		.then(_configureAuth0Client);
}

function _configureAuth0Client(authSettings): Promise<Auth0Client> {
    return createAuth0Client({
        client_id: authSettings.clientId,
        domain: AUTH0_DOMAIN,
        connection: authSettings.connection,
        audience: authSettings.audience,
        grant_type: 'http://auth0.com/oauth/grant-type/password-realm',
        response_type: 'token id_token',
        redirect_uri: AUTH0_CALLBACK_URL,
        scope: authSettings.scopes
    });
}